// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__293HT","breadcrumbDivider":"Breadcrumb_breadcrumbDivider__2D24R"};